import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useViewPastPaperById = (id) => {
  const formData = {};
  if (id) formData.id = id;

  return useQuery(
    ["viewPastPaperById", id],
    async () => {
      const { data } = await axiosPost("/api/cw/viewPastPaper", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useViewPastPaperById;
